import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../Axios/AxiosInstance';
import './PainterList.css';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import { TableTextConstants, TextConstants } from '../../Constants/Constants';
import ReusableTable from '../../Components/Table/ReusableTable';

const PainterList = () => {
  const { date, dealerId } = useParams();
  const [painterData, setPainterData] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageDataRef = useRef({});
  
  const navigate = useNavigate();

  useEffect(() => {
    fetchPainterData();
  }, [date, dealerId,currentPage,rowsPerPage]);

  const fetchPainterData = async () => {
    const cacheKey = `${currentPage}-${rowsPerPage}`;
    if (pageDataRef.current[cacheKey]) {
      setPainterData(pageDataRef.current[cacheKey]);
    } else {
      setIsLoading(true);
      try {
        const response = await axiosInstance.get(`/Approval/GetPainterDataByDealer?selectedDate=${date}&dealerId=${dealerId}`, {
          params: {
            PageNumber: currentPage,
            PageSize: rowsPerPage,
          },
        });
  
        const { approvalPainterData, paginatedData } = response.data;
  
        if (approvalPainterData && Array.isArray(approvalPainterData)) {
          const formattedData = approvalPainterData.map(item => {
            const [year, month, day] = item.scannedDate.split('T')[0].split('-');
            const formattedDate = `${day}/${month}/${year}`;
  
            return {
              scannedDate: formattedDate,
              painterName: item.painterName,
              dealerName: item.dealerName,
              handlingCharges: item.handlingCharges,
              totalAmount: item.totalAmount,
              totalFinalAmount: item.totalFinalAmount,
              dealerId: item.dealerId,
              painterId: item.painterId
            };
          });
  
          console.log(formattedData, 'mahesh');
  
          setPainterData(formattedData);
          setTotalRecords(paginatedData.totalRecords);
          pageDataRef.current[cacheKey] = formattedData;
        } else {
          console.error('Data format is incorrect or missing:', approvalPainterData);
        }
      } catch (error) {
        console.error('Error fetching approval data:', error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  

  const columns = [
    { key: 'scannedDate', label: 'Date' },
    { key: 'dealerName', label: 'Dealer Name' },
    { key: 'painterName', label: 'Painter Name' },
    { key: 'totalAmount', label: 'Amount', isTextAlignRight: true, isCurrency: true },
    { key: 'handlingCharges', label: 'Handling Fee', isTextAlignRight: true, isCurrency: true },
    { key: 'totalFinalAmount', label: 'Total Amount', isTextAlignRight: true, isCurrency: true },
  ];

  const handleSelectedRowsChange = (newSelectedRows) => {
    setSelectedRows(newSelectedRows);
  };


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = Number(event.target.value);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };


  const handleEyeClick = (row) => {
    const { dealerId, scannedDate, painterId} = row;
    const [day, month, year] = scannedDate.split('/');
    const formattedDate = `${year}-${month}-${day}`;
    navigate(`/product-list/${formattedDate}/${dealerId}/${painterId}`);
  };

  return (

    <div className="flex flex-col min-h-screen">
    <Header title={`${TextConstants.painterListTitle}`}/>
    <div className="flex flex-col flex-1 mx-2 my-3">
    <div className="flex justify-end">
       <div className="bg-[#1e365e] text-white px-3.5 py-2 rounded-full shadow-md">
         <span className="text-md">
          Date: {new Date(date).toLocaleDateString('en-GB')}
         </span>
       </div>
     </div>

     <div className="mt-3 p-1">
         <ReusableTable
           data={painterData}
           columns={columns}
           rowsPerPage={rowsPerPage}
           loading={isLoading}
           currentPage={currentPage}
           totalRecords={totalRecords}
           onPageChange={handlePageChange}
           onRowsPerPageChange={handleRowsPerPageChange}
           onSelectedRowsChange={handleSelectedRowsChange}
           enableEye={true}
           onEyeClick={handleEyeClick}
         />
       </div>

    </div>
     <Footer/>
   </div>
  );
};

export default PainterList;
